export default "__VITE_ASSET__CYKe3vzO__"